<script setup lang="ts">
import type { AgentOnPage } from '@@/shared/agent/api-types';
import type { AgentOnList } from '@@/shared/agent/types';

defineProps<{
  agent: AgentOnPage | AgentOnList
}>();

const emit = defineEmits<{
  contact: []
}>();
</script>

<template>
  <IadStickySmallDevice>
    <AgentAvatarNavigation
      :agent
      class="flex-1"
    />
    <div class="flex gap-s flex-none">
      <IadBtn
        size="large"
        icon
        @click="emit('contact')"
      >
        <Icon
          class="size-6"
          name="iad-icon:mail"
        />
      </IadBtn>
      <AgentBtnPhone
        icon
        :agent
      />
    </div>
  </IadStickySmallDevice>
</template>
